module.exports = __webpack_public_path__ + "static/css-page-8-4-534bd6f776ca37619d72e396b6f6bd99.jpg";